export const subjectVariablesSectionMessagesEn = {
  // Cohort Builder - Subject Variables Content
  'projects.cohortBuilderPage.subjectVariablesSection.title': 'Subject variables',
  'projects.cohortBuilderPage.subjectVariablesSection.buttonLabel': 'Create criterion',
  'projects.cohortBuilderPage.subjectVariablesSection.nameItemLabel': 'Name',
  'projects.cohortBuilderPage.subjectVariablesSection.typeItemLabel': 'Type',
  'projects.cohortBuilderPage.subjectVariablesSection.noSubjectVariablesMainMsg':
    'No subject variables',
  'projects.cohortBuilderPage.subjectVariablesSection.noSubjectVariablesSubMsg':
    'Set a subject variable to get started',

  // cohort builder components - SubjectVariableEditCard
  'projects.cohortBuilderPage.subjectVariableEditCard.titleAdd': 'Create criterion',
  'projects.cohortBuilderPage.subjectVariableEditCard.titleEdit': 'Edit criterion',
  'projects.cohortBuilderPage.subjectVariableEditCard.titleView': 'View criterion',
  'projects.cohortBuilderPage.subjectVariableEditCard.cancelBtn': 'Cancel',
  'projects.cohortBuilderPage.subjectVariableEditCard.closeBtn': 'Close',
  'projects.cohortBuilderPage.subjectVariableEditCard.saveBtn': 'Criterion',
  'projects.cohortBuilderPage.subjectVariableEditCard.description':
    'Subject variables are used to take event variables and roll them up to a person. They can also be variables that live at the subject level (e.g. Demographics).',
  'projects.cohortBuilderPage.subjectVariableEditCard.nameLabel': 'Name',
  'projects.cohortBuilderPage.subjectVariableEditCard.namePlaceholder': 'Enter criterion name',
  'projects.cohortBuilderPage.subjectVariablesSection.addConceptFilter': 'Concept filter',
  'projects.cohortBuilderPage.subjectVariablesSection.addNumericFilter': 'Numeric filter',
  'projects.cohortBuilderPage.subjectVariablesSection.conceptFilterSection.title':
    'Concept filters',
  'projects.cohortBuilderPage.subjectVariablesSection.numericFilterSection.title':
    'Numeric filters',
  'projects.cohortBuilderPage.subjectVariablesSection.countFilterSection.title': 'Count filter',
  'projects.cohortBuilderPage.subjectVariableEditCard.cancelButtonText': 'Close',
  'projects.cohortBuilderPage.subjectVariableEditCard.ieCriteria.label': 'I/E criteria',
  'projects.cohortBuilderPage.subjectVariableEditCard.ieCriteria.inclusion': 'Inclusion',
  'projects.cohortBuilderPage.subjectVariableEditCard.ieCriteria.exclusion': 'Exclusion',
  'projects.cohortBuilderPage.subjectVariableEditCard.ieCriteria.notApplied': 'Not applied',

  // cohort builder components - SubjectVariableDeleteModal
  'projects.cohortBuilderPage.subjectVariableDeleteModal.title': 'Delete subject variable',
  'projects.cohortBuilderPage.subjectVariableDeleteModal.submittingTitle':
    'Deleting subject variable',
};
